import { render, staticRenderFns } from "./DirectionsBannerBlock.vue?vue&type=template&id=10abf707&scoped=true&"
import script from "./DirectionsBannerBlock.vue?vue&type=script&lang=js&"
export * from "./DirectionsBannerBlock.vue?vue&type=script&lang=js&"
import style0 from "./DirectionsBannerBlock.vue?vue&type=style&index=0&id=10abf707&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10abf707",
  null
  
)

export default component.exports